import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-aria-menubutton';
import { MenuItemContainer, MenuItemCheckMarkWrapper, MenuItemCheckMark, DisabledMenuItem } from './styles';
const SelectItem = ({
  label,
  checkmark = false,
  isSelected,
  value,
  text,
  // selectedLabel is not used by this component directly, but instead extracted by the Select component when iterating through children.
  selectedLabel,
  disabled = false,
  ...props
}) => /*#__PURE__*/React.createElement(MenuItemContainer, _extends({
  as: disabled ? DisabledMenuItem : MenuItem
}, props, {
  text,
  value,
  tag: "li",
  "data-value": value,
  "aria-disabled": disabled
}), checkmark ? /*#__PURE__*/React.createElement(MenuItemCheckMarkWrapper, null, /*#__PURE__*/React.createElement("div", null, label), /*#__PURE__*/React.createElement(MenuItemCheckMark, {
  $isSelected: isSelected,
  "aria-hidden": true
})) : label);
SelectItem.propTypes = {
  label: PropTypes.node.isRequired,
  selectedLabel: PropTypes.node,
  value: PropTypes.string.isRequired,
  // this prop is required to show to the user the selected item.
  checkmark: PropTypes.bool,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool
};
export default SelectItem;
//# sourceMappingURL=SelectItem.js.map